import React, { useContext, useState } from "react";
import Form from "../components/form/elements/Form";
import InputField from "../components/form/elements/InputField";
import Button from "../components/ui/Button";
import auth from "../services/authServices";
import {
    getFormData,
    handleFormErrors,
    handleFormSubmit,
    handleInputChange,
} from "../services/formServices";
import http from "../services/httpServices";
import AuthContext from "../context/AuthContext";
import CenterIcon from "../components/ui/CenterIcon";

const initialState = {
    description: "",
    file: "",
};

const CommunityCreateCommentForm = ({ category, posts, setPosts, post }) => {
    const [data, setData] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isShownAddComment, setIsShownAddComment] = useState(false);

    const { user } = useContext(AuthContext);
    const handleSubmit = async (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, async () => {
            setIsLoading(true);
            const token = auth.getToken();
            const config = auth.getAuthConfig(token);
            try {
                const formData = getFormData(data);
                let { data: response } = await http.post(
                    `/api/community_categories/${category["id"]}/posts/${post["id"]}/comments`,
                    formData,
                    config
                );
                response = {
                    ...response,
                    user: { full_name: user.full_name },
                };
                setPosts(
                    posts.map((item) => {
                        if (item.id !== post.id) {
                            return item;
                        }
                        item.community_comments_count++;
                        item.community_comments = [response, ...item.community_comments];
                        return item;
                    })
                );
                setIsLoading(false);
                setIsShownAddComment(false);
                setData(initialState);
            } catch ({ response }) {
                handleFormErrors(response, setIsLoading, setErrors, false);
            }
        });
    };
    return (
        <>
            {category.is_closed || post.is_closed ? (
                ""
            ) : isShownAddComment ? (
                <div className="pt-4 flex-center-both">
                    <Form
                        className="flex-center-both w-full max-w-md mx-auto p-5 rounded-md clr-text-primary smooth shadow-md bg-cyan-500 bg-opacity-20 relative"
                        onSubmit={handleSubmit}
                    >
                        <div
                            className="absolute top-0 right-0 p-3 cursor-pointer"
                            onClick={() => setIsShownAddComment(false)}
                        >
                            <CenterIcon icon="tabler:x" />
                        </div>
                        <div className="w-full space-y-4">
                            <InputField
                                id="description"
                                type="textarea"
                                placeholder="اكتب تعليق"
                                setData={setData}
                                data={data}
                                errors={errors}
                                onChange={handleInputChange}
                            />

                            <div className="space-y-2">
                                <div className="">هل تريد ارفاق صورة؟</div>
                                <InputField
                                    id="image"
                                    type="file"
                                    placeholder="ارفق صورة"
                                    isRequired={false}
                                    inputProps={{ accept: "image/png, image/gif, image/jpeg" }}
                                    setData={setData}
                                    data={data}
                                    errors={errors}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="flex-center-both">
                                <Button color="cyan" isLoading={isLoading}>
                                    {"ارسال التعليق"}
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            ) : (
                <div className="pt-3  flex flex-row space-x-2 space-x-reverse w-full flex-center-both">
                    <div
                        className="w-full rounded-lg bg-cyan-400 bg-opacity-40 hover:bg-opacity-60 smooth clr-text-secondary py-1 px-4 font-w-bold cursor-pointer font-smaller max-w-sm"
                        onClick={() => setIsShownAddComment(!isShownAddComment)}
                    >
                        شاركنا بتعليقك هنا !
                    </div>
                </div>
                // <div className="flex-center-both">
                //     <Button color="cyan" >
                //         اترك تعليقًا !
                //     </Button>
                // </div>
            )}
        </>
    );
};

export default CommunityCreateCommentForm;
